interface FilterIconProps {
  size?: number;
  className?: string;
}

export function IconFilter({ size = 20, className }: FilterIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className}>
      <path
        stroke={"currentColor"}
        fill="none"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 13 2 3h20l-8 10v8h-4v-8Z"
      />
    </svg>
  );
}
